import { Identifiable } from '../auditable-entity';

export function compareByUuid(a: Identifiable, b: Identifiable): boolean {
  return a && b && a.uuid === b.uuid;
}
